// extracted by mini-css-extract-plugin
module.exports = {"container":"Header-module__container--2XWLB","searchPlusChip":"Header-module__searchPlusChip--3ktV5"};